export default {"src":"/_next/static/media/gradient-link-arrow.84039162.svg","height":19,"width":18,"blurWidth":0,"blurHeight":0};